module.exports = __webpack_public_path__ + "media/images/lave-linge-b08fcc308b075ac3cc6a30eaedacdc78.svg";